import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('vehiclePrices', {
  customKeys: {
    list: 'vehicle_prices',
  },
  customEndpoints: {
    delete: '/vehicle_prices/:id/deactivate',
  },
  customMethods: {
    delete: 'get',
  },
});
